import {PROVIDER_FOCUS_BUTTON_CLASS} from "./interactions";
import {renderEntityAvatar} from "../../helpers/render_avatar";

const SELECT_PROVIDER_CONTAINER = "selected-provider-container";

const renderProviderDetails = (provider) => {
    const container = document.getElementById(SELECT_PROVIDER_CONTAINER);
    if (!container || !provider) return; // Don't render anything
    container.innerHTML = providerDetailsTemplate(provider);
}

const providerDetailsTemplate = (provider) => {
    return `
<div class="selected-provider shadow-md shadow-slate-400 rounded-lg overflow-hidden">
    <div class="px-4 pt-4 flex justify-between flex-row items-start">
    ${renderEntityAvatar(provider, {
        width: "3.5rem",
        fontSize: "1.5rem",
        backgroundColor: provider.avatar_background_colour
    }).outerHTML}
        <div>
            <span class="me-2 text-xs ${provider.work_status_icon.htmlClass}">
                ${provider.work_status_icon.text}
            </span>
            <span class="text-xs ${provider.type_of_provider.htmlClass}">
                ${provider.type_of_provider.text}
            </span>
        </div>
        
    </div>

    <div class="p-4">
        <div class="flex items-center justify-start">
            <button data-provider-id="${provider.id}" class="${PROVIDER_FOCUS_BUTTON_CLASS.substring(1)} text-black opacity-50 hover:text-ascendPurple-dark transition p-1 -ms-1 hover:opacity-100">
                <i class="fas fa-location-crosshairs cursor-pointer pointer-events-none"></i>    
            </button>
            <a href="/providers/${provider.id}">
                <h2 class="text-xl font-semibold hover:underline cursor-pointer">${provider.first_name} ${provider.last_name}</h2>
            </a>
        </div>
        <p class="text-gray-700">${provider.full_address}</p>
    </div>
</div>
`;
}

export default renderProviderDetails;